export const FETCH_ACTIVE_ROOM = 'fetch/active-room'
export const FETCH_LIST_ROOMS = 'fetch/list-rooms'
export const SET_NEW_MESSAGE = 'set/new-message'
export const SET_LOADING_MESSAGE = 'set/loading-message'
